// Whole-count ticks and bars share this even ceiling, so a one-action bar is
// halfway up a 0–2 scale and odd peaks never produce fractional count labels.
export function countChartScale(maximum: number) {
  const ceiling = Math.max(2, Math.ceil(maximum / 2) * 2);
  return { ceiling, middle: ceiling / 2 };
}
